import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.JaWVgv',
    defaultMessage: 'SAML',
  },
  error: {
    id: 'studio.Dxf87T',
    defaultMessage: 'There was a problem loading the SAML secrets.',
  },
  loading: {
    id: 'studio.TBPF+A',
    defaultMessage: 'Loading SAML secrets…',
  },
  noSecrets: {
    id: 'studio.183Swc',
    defaultMessage: 'No SAML secrets have been configured yet.',
  },
  addNew: {
    id: 'studio.v9WChN',
    defaultMessage: 'Add new secret',
  },
});
